export enum SortableDocumentColumn {
    FILE_NAME = 'fileName',
    CREATOR = 'creator',
    FILE_SIZE = 'fileSize',
    FILE_TYPE = 'fileExtension',
    CREATION_DATE = 'creationTime',
}

export enum DocumentsTab {
    DOCUMENT_EXCHANGE = 'document-exchange',
    E_DOSSIER = 'e-dossier',
}
